import React from "react";

export default function UAEFlag({ size = 32, className = "" }) {
  const width = size * 1.5;
  const height = size;

  return (
    <div
      className={`relative ${className}`}
      style={{ width, height }}
      role="img"
      aria-label="UAE Flag"
    >
      <svg
        viewBox="0 0 60 40"
        width={width}
        height={height}
        className="uae-flag-wave"
        style={{ filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.15))" }}
      >
        <defs>
          <clipPath id="flagClip">
            <rect x="0" y="0" width="60" height="40" rx="1" />
          </clipPath>
        </defs>

        <g clipPath="url(#flagClip)">
          {/* Green stripe - top */}
          <rect x="15" y="0" width="45" height="13.33" fill="#00732F" />

          {/* White stripe - middle */}
          <rect x="15" y="13.33" width="45" height="13.34" fill="#FFFFFF" />

          {/* Black stripe - bottom */}
          <rect x="15" y="26.67" width="45" height="13.33" fill="#000000" />

          {/* Red vertical bar - hoist side */}
          <rect x="0" y="0" width="15" height="40" fill="#FF0000" />
        </g>

        {/* Subtle border */}
        <rect
          x="0.5" y="0.5"
          width="59" height="39"
          rx="1"
          fill="none"
          stroke="rgba(0,0,0,0.1)"
          strokeWidth="0.5"
        />
      </svg>

      <style>{`
        @keyframes flagWave {
          0% {
            transform: perspective(150px) rotateY(0deg) skewX(0deg) scaleX(1);
          }
          10% {
            transform: perspective(150px) rotateY(12deg) skewX(-2deg) scaleX(0.96);
          }
          25% {
            transform: perspective(150px) rotateY(-8deg) skewX(1.5deg) scaleX(1.02);
          }
          40% {
            transform: perspective(150px) rotateY(10deg) skewX(-1.5deg) scaleX(0.97);
          }
          55% {
            transform: perspective(150px) rotateY(-6deg) skewX(1deg) scaleX(1.01);
          }
          70% {
            transform: perspective(150px) rotateY(8deg) skewX(-1deg) scaleX(0.98);
          }
          85% {
            transform: perspective(150px) rotateY(-4deg) skewX(0.5deg) scaleX(1.005);
          }
          100% {
            transform: perspective(150px) rotateY(0deg) skewX(0deg) scaleX(1);
          }
        }

        @keyframes flagRipple {
          0%, 100% {
            filter: drop-shadow(0 1px 2px rgba(0,0,0,0.15));
          }
          30% {
            filter: drop-shadow(2px 3px 4px rgba(0,0,0,0.25));
          }
          60% {
            filter: drop-shadow(-1px 2px 3px rgba(0,0,0,0.2));
          }
        }

        .uae-flag-wave {
          animation:
            flagWave 2.5s ease-in-out infinite,
            flagRipple 1.8s ease-in-out infinite;
          transform-origin: left center;
          transform-style: preserve-3d;
        }
      `}</style>
    </div>
  );
}
